import { useVisitorTracking } from "@/hooks/useVisitorTracking";

export const VisitorTracker = () => {
  useVisitorTracking();
  return null;
};
